import { render } from "./yos-dialog.vue?vue&type=template&id=11ea72fb"
import script from "./yos-dialog.vue?vue&type=script&lang=js"
export * from "./yos-dialog.vue?vue&type=script&lang=js"

import "./yos-dialog.vue?vue&type=style&index=0&id=11ea72fb&lang=postcss"
script.render = render

export default script